function StaffChangePassword() {
    return (
      <div className="App">
          StaffChangePassword
      </div>
    );
  }
  export default StaffChangePassword;